import Const from 'constants';
import Action from 'actions';

const NonControlledHitterStackingAction = {
    useStacking(use) {
        return {
            type: Const.NON_CONTROLLED_HITTER_STACKING_IS_USED,
            use,
        };
    },

    setTeams(teams) {
        return (dispatch) => {
            dispatch({
                type: Const.NON_CONTROLLED_HITTER_STACKING_SET_TEAMS,
                teams,
            });
        };
    },

    setTeamsAreChosenRandomly(chooseTeamsRandomly) {
        return (dispatch) => {
            dispatch({
                type: Const.NON_CONTROLLED_HITTER_STACKING_SET_TEAMS_ARE_CHOSEN_RANDOMLY,
                chooseTeamsRandomly,
            });

            dispatch(this.saveNonControlledHitterStackingToStorage());
        };
    },

    setPlayersQuantityForStackNumber(playersQuantity, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NON_CONTROLLED_HITTER_STACKING_SET_PLAYERS_QUANTITY,
                playersQuantity,
                stackNumber,
            });

            dispatch(this.saveNonControlledHitterStackingToStorage());
        };
    },

    setStackTeamsIsCheckedForStackNumber(checked, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NON_CONTROLLED_HITTER_STACKING_SET_STACK_TEAMS_IS_CHECKED,
                checked,
                stackNumber,
            });

            dispatch(this.saveNonControlledHitterStackingToStorage());
        };
    },

    setStackTeamsExposureForStackNumber(exposure, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NON_CONTROLLED_HITTER_STACKING_SET_STACK_TEAMS_EXPOSURE,
                exposure,
                stackNumber,
            });

            dispatch(this.saveNonControlledHitterStackingToStorage());
        };
    },

    setBattingOrderForStackNumber(order, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NON_CONTROLLED_HITTER_STACKING_SET_BATTING_ORDER,
                order,
                stackNumber,
            });

            dispatch(this.saveNonControlledHitterStackingToStorage());
        };
    },

    setTeamIsCheckedForStackNumber(team, checked, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NON_CONTROLLED_HITTER_STACKING_SET_TEAM_IS_CHECKED,
                team,
                checked,
                stackNumber,
            });

            dispatch(this.saveNonControlledHitterStackingToStorage());
        };
    },

    setTeamExposureForStackNumber(team, exposure, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NON_CONTROLLED_HITTER_STACKING_SET_TEAM_EXPOSURE,
                team,
                exposure,
                stackNumber,
            });

            dispatch(this.saveNonControlledHitterStackingToStorage());
        };
    },

    setCombinationIsChecked(comboKey, checked) {
        return (dispatch) => {
            dispatch({
                type: Const.NON_CONTROLLED_HITTER_STACKING_SET_COMBO_IS_CHECKED,
                comboKey,
                checked,
            });

            dispatch(this.saveNonControlledHitterStackingToStorage());
        };
    },

    setCombinationExposure(comboKey, exposure) {
        return (dispatch) => {
            dispatch({
                type: Const.NON_CONTROLLED_HITTER_STACKING_SET_COMBO_EXPOSURE,
                comboKey,
                exposure,
            });

            dispatch(this.saveNonControlledHitterStackingToStorage());
        };
    },

    setNonControlledHittersStackingSettingsFromStorage(data) {
        return (dispatch) => {
            dispatch({
                type: Const.NON_CONTROLLED_HITTER_STACKING_SET_DATA_FROM_STORAGE,
                data,
            });
        };
    },

    mirrorStack(sourceStackNumber, destinationStackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NON_CONTROLLED_HITTER_STACKING_MIRROR_STACK,
                sourceStackNumber,
                destinationStackNumber,
            });

            dispatch(this.saveNonControlledHitterStackingToStorage());
        };
    },

    saveNonControlledHitterStackingToStorage() {
        return (dispatch) => {
            dispatch(
                Action.saveDataToStorage('nonControlledHitterStackingSettings', function (state) {
                    const {
                        nonControlledHitterStacking: {settings},
                    } = state;

                    return {...settings.data};
                }),
            );
        };
    },
};

export default NonControlledHitterStackingAction;
